import { motion } from "framer-motion";
import { Building2, Stethoscope, Heart } from "lucide-react";
import { Button } from "@/components/ui/button";

export function PartnerCTASection() {
  const partnerOptions = [
    {
      icon: Building2,
      title: "Hospitals",
      description: "Integrate with your existing triage systems"
    },
    {
      icon: Stethoscope,
      title: "Clinics",
      description: "Optimise patient flow and resource allocation"
    },
    {
      icon: Heart,
      title: "Health Networks",
      description: "Deploy at scale across your entire system"
    }
  ];

  return (
    <section id="contact" className="py-20 relative z-10 bg-white dark:bg-black">
      <div className="container mx-auto px-6">
        <motion.div 
          className="max-w-4xl mx-auto text-center bg-white dark:bg-black"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
        >
          <h2 className="text-3xl md:text-4xl font-bold mb-6 text-black dark:text-white">
            Partner with <span className="text-[#14b8a6]">Elevita</span>
          </h2>
          <p className="text-xl text-black dark:text-white mb-12 max-w-2xl mx-auto">
            Want to trial Elevita, collaborate on a tender, or bring this to your hospital or region? Reach out directly to start the conversation.
          </p>
          
          <motion.div
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            <Button
              asChild
              className="cta-button inline-block bg-[#14b8a6] text-black font-bold text-xl px-10 py-7 h-auto rounded-lg hover:bg-[#0f8a7d] transition-colors shadow-lg relative"
            >
              <a href="mailto:bec@curalysis.com">
                bec@curalysis.com
              </a>
            </Button>
          </motion.div>
          
          <motion.div 
            className="mt-12 grid md:grid-cols-3 gap-6 max-w-3xl mx-auto"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ 
              duration: 0.8, 
              delay: 0.4,
              staggerChildren: 0.1
            }}
          >
            {partnerOptions.map((option, index) => (
              <motion.div 
                key={index}
                className="p-6 rounded-lg bg-white dark:bg-black bg-opacity-40 border border-gray-800 hover:border-[#14b8a6] transition-all duration-300"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-100px" }}
                transition={{ duration: 0.5, delay: 0.4 + index * 0.1 }}
              >
                <div className="w-12 h-12 bg-[#14b8a6] bg-opacity-20 rounded-full flex items-center justify-center mb-4 mx-auto">
                  <option.icon className="text-[#14b8a6]" size={20} />
                </div>
                <h3 className="font-bold mb-2 text-center text-teal-600 dark:text-teal-400">{option.title}</h3>
                <p className="text-sm text-gray-800 dark:text-gray-200 text-center">{option.description}</p>
              </motion.div>
            ))}
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
